import { FC } from 'react'
import styled from 'styled-components'
import { TextLegacy } from '@/components/common'
import { GlobalColorEnum } from '@/constants/global-color.enum'
import { useChannelTalk } from '@/containers/hooks/useChannelTalk'

const OneOnOneInquiryButton: FC = () => {
  const { showMessenger } = useChannelTalk()

  const handleClick = () => {
    showMessenger()
  }

  return (
    <StyledInquirySection onClick={() => handleClick()}>
      <TextLegacy size={16} weight={600} color={GlobalColorEnum.GrayWhite}>
        1:1 문의
      </TextLegacy>
    </StyledInquirySection>
  )
}

export default OneOnOneInquiryButton

const StyledInquirySection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 16px;
  bottom: 48px;
  width: 92px;
  height: 44px;
  box-shadow: 0px 4px 8px rgba(66, 73, 79, 0.25);
  border-radius: 30px;
  background: ${(props) => props.theme.color.gray900};

  -ms-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
`
